import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  Companion_getInstance335jj07k1liay as Companion_getInstance,
  Concreteni4fg10vz3zt as Concrete,
} from './VirtualType.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { tryTypeParameterSerializers1jrcyh9alxuh0 as tryTypeParameterSerializers } from './SerializationHelpers.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_serClassToList() {
  _init_properties_SerializableProperty_kt__xtu0z0();
  return serClassToList;
}
var serClassToList;
function get_annotations() {
  // Inline function 'kotlin.collections.listOf' call
  return emptyList();
}
function get_serializableAnnotations() {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = this.bz();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver = Companion_getInstance().o4r(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver);
    }
  }
  return destination;
}
var SerializablePropertyClass;
function SerializableProperty() {
  if (SerializablePropertyClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SerializableProperty');
    SerializablePropertyClass = $;
  }
  return SerializablePropertyClass;
}
function get_serializableProperties(_this__u8e3s4) {
  _init_properties_SerializableProperty_kt__xtu0z0();
  var tmp0_safe_receiver = get_serClassToList().p3(_this__u8e3s4.az().h10());
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp1_elvis_lhs = tryTypeParameterSerializers(_this__u8e3s4);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    tmp = tmp0_safe_receiver(tmp_0);
  }
  var tmp_1 = tmp;
  var tmp2_elvis_lhs = (!(tmp_1 == null) ? isArray(tmp_1) : false) ? tmp_1 : null;
  var tmp_2;
  if (tmp2_elvis_lhs == null) {
    var tmp3_safe_receiver = _this__u8e3s4 instanceof Concrete() ? _this__u8e3s4 : null;
    var tmp_3 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.r4r();
    tmp_2 = (!(tmp_3 == null) ? isArray(tmp_3) : false) ? tmp_3 : null;
  } else {
    tmp_2 = tmp2_elvis_lhs;
  }
  return tmp_2;
}
function properties(_this__u8e3s4, action) {
  _init_properties_SerializableProperty_kt__xtu0z0();
  var tmp0 = get_serClassToList();
  var tmp2 = _this__u8e3s4.az().h10();
  // Inline function 'kotlin.collections.set' call
  var value = typeof action === 'function' ? action : THROW_CCE();
  tmp0.s3(tmp2, value);
}
var properties_initialized_SerializableProperty_kt_5bf7pm;
function _init_properties_SerializableProperty_kt__xtu0z0() {
  if (!properties_initialized_SerializableProperty_kt_5bf7pm) {
    properties_initialized_SerializableProperty_kt_5bf7pm = true;
    serClassToList = HashMap().n8();
  }
}
//region block: exports
export {
  get_annotations as get_annotations2g7n6lqltzfk6,
  get_serializableAnnotations as get_serializableAnnotations132wwdaanmitj,
  SerializableProperty as SerializableProperty3ugfzrmvjw266,
  properties as properties1qnxlk10mmfrs,
  get_serializableProperties as get_serializableProperties2tbouuwr11am9,
};
//endregion

//# sourceMappingURL=SerializableProperty.mjs.map
